import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-25',
  templateUrl: './25.component.html',
  styleUrls: ['./25.component.scss'],
})
export class VbGeneral25Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
